import { z } from 'zod'

const schema = z.object({
  ownLanguage: z.string(),
  fanLanguage: z.string().nullable(),
  translatorEnabled: z.boolean(),
  enabled: z.boolean(),
})

export type FormValues = z.infer<typeof schema>
export const FORM_ID = 'translation-config-form'
